import { Grid, Paper, Typography, withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { getClaim } from '../../../claim';
import { ClaimType } from '../../../claim/claim-types';
import { LabeledValue } from '../../../controls/labeled-value';
import { State } from '../../../redux/root-reducer';
import { Nullable } from '../../../shared-types';
import styles, { StyledComponent } from '../../../styles/styles';
import {
    BeneficiaryDetails,
    getIdType,
    getPaymentBeneficiaries,
    idNumberFormatter,
    Payment,
    PaymentItem,
} from '../../reducer';
import { AddPaymentButton } from './add-payment-item';
import { BankingDetailsExpansionView } from './banking-details-expansion';
import { FuneralPaymentItems } from './funeral/payment-items-view';
import { PaymentItemsView } from './payment-items-view';
import { ButtonWrapper } from '../../../forms/form-components/button-wrapper/index';
import { OverrideHighRiskDetailsView } from '../high-risk-override/high-risk-override-view';
import { BeneficiatyRiskRatingDetailsView } from './beneficiary-risk-rating';
import { WTIDetailsExpansionView } from './wti-expansion';
import { Warning } from '@material-ui/icons';

interface OwnProps extends StyledComponent {
    beneficiaries: BeneficiaryDetails[];
    claimType: Nullable<ClaimType>;
    payments: Payment[];
}

type Props = OwnProps;

const beneficiaryPaymentsView: React.FunctionComponent<Props> = ({
    beneficiaries,
    claimType,
    classes,
    payments,
}: Props) => {
    if (!payments || payments.length === 0) {
        return null;
    }

    return (
        <React.Fragment>
            {payments.map((payment, paymentIndex) => {
                const beneficiary = beneficiaries.find(
                    b => b.beneficiaryId === payment.beneficiaryId
                );
                if (!beneficiary) {
                    return null;
                }
                const beneficiaryId = beneficiary.beneficiaryId;
                const personalDetails = beneficiary.personalDetails;
                const organisationDetails = beneficiary.organisationDetails;
                const idType = personalDetails && personalDetails.idType;
                const isPassport = getIdType(idType);
                return (
                    <Paper className={classes.paper} key={paymentIndex}>
                        <Grid container item xs={6} alignItems="center">
                            <Typography variant="h6">Beneficiary Details</Typography>
                        </Grid>
                        {personalDetails && (
                            <Grid item xs={12} container justify="flex-start">
                                {claimType === ClaimType.RADeath &&
                                    beneficiary?.emailAddress === null &&
                                    beneficiary?.wtiCountry === null &&
                                    beneficiary?.wtiException === null && (
                                        <Grid item xs={12} lg={12}>
                                            <Typography style={{ color: '#8b92a7' }}>
                                                {isWTICapture()}
                                                Please ensure sure that you capture WTI Details
                                                before paymentss
                                            </Typography>
                                        </Grid>
                                    )}
                                {claimType === ClaimType.RADeath &&
                                    beneficiary?.contactDetails?.emailAddress === null &&
                                    beneficiary?.contactDetails?.preferredMethodOfCommunication ===
                                        null &&
                                    beneficiary?.contactDetails?.cellphoneNumber === null && (
                                        <Grid item xs={12} lg={12}>
                                            <Typography style={{ color: '#8b92a7' }}>
                                                {isWTICapture()}
                                                Please ensure sure that you capture Contact Details
                                                before paymentss
                                            </Typography>
                                        </Grid>
                                    )}
                                {claimType === ClaimType.RADeath &&
                                    beneficiary?.residentialAddress?.addressLine1 === null &&
                                    beneficiary?.residentialAddress?.addressLine2 === null &&
                                    beneficiary?.residentialAddress?.suburb === null &&
                                    beneficiary?.residentialAddress?.country === null &&
                                    beneficiary?.residentialAddress?.town === null &&
                                    beneficiary?.residentialAddress?.province === null && (
                                        <Grid item xs={12} lg={12}>
                                            <Typography style={{ color: '#8b92a7' }}>
                                                {isWTICapture()}
                                                Please ensure sure that you capture Address Details
                                                before paymentss
                                            </Typography>
                                        </Grid>
                                    )}
                                {claimType === ClaimType.RADeath &&
                                    beneficiary.raBankingDetails === null && (
                                        <Grid item xs={12} lg={12}>
                                            <Typography style={{ color: '#8b92a7' }}>
                                                {isBankingCapture()}
                                                Please ensure sure that you capture Banking Details
                                                before payment
                                            </Typography>
                                        </Grid>
                                    )}
                                {claimType === ClaimType.RADeath &&
                                    beneficiary.financialInformation?.hasFinancialAdviser ===
                                        null &&
                                    beneficiary.financialInformation?.dependentOnLifeAssured ===
                                        null && (
                                        <Grid item xs={12} lg={12}>
                                            <Typography style={{ color: '#8b92a7' }}>
                                                {isBankingCapture()}
                                                Please ensure sure that you capture Financial
                                                Details before payment
                                            </Typography>
                                        </Grid>
                                    )}
                                <Grid item xs={4} lg={2}>
                                    <LabeledValue label="Name" value={personalDetails.firstName} />
                                </Grid>
                                <Grid item xs={4} lg={2}>
                                    <LabeledValue
                                        label="Surname"
                                        value={personalDetails.lastName}
                                    />
                                </Grid>
                                {!isPassport ? (
                                    <Grid item xs={4} lg={2}>
                                        <LabeledValue
                                            label="ID Number"
                                            value={idNumberFormatter(
                                                personalDetails && personalDetails.idNumber
                                            )}
                                        />
                                    </Grid>
                                ) : (
                                    <Grid item xs={4} lg={2}>
                                        <LabeledValue
                                            label="Passport Number"
                                            value={personalDetails.passportNumber}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        )}
                        {organisationDetails && (
                            <Grid item xs={12} container justify="flex-start">
                                <Grid item xs={4} lg={2}>
                                    <LabeledValue
                                        label="Name"
                                        value={organisationDetails.companyName}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={2}>
                                    <LabeledValue
                                        label="Registration Number"
                                        value={organisationDetails.entityRegistrationNumber}
                                    />
                                </Grid>
                                {organisationDetails.companyTaxNumber && (
                                    <Grid item xs={4} lg={2}>
                                        <LabeledValue
                                            label="Tax Number"
                                            value={organisationDetails.companyTaxNumber}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        )}
                        {claimType === ClaimType.RADeath && (
                            <WTIDetailsExpansionView
                                beneficiaryId={beneficiaryId}
                                payments={payments}
                                paymentIndex={paymentIndex}
                            />
                        )}
                        <BankingDetailsExpansionView
                            beneficiaryId={beneficiaryId}
                            payments={payments}
                            paymentIndex={paymentIndex}
                        />

                        <BeneficiatyRiskRatingDetailsView
                            beneficiaryId={beneficiaryId}
                            paymentIndex={paymentIndex}
                        />
                        <OverrideHighRiskDetailsView
                            payments={payments}
                            paymentIndex={paymentIndex}
                        />
                        <ButtonWrapper>
                            {claimType !== ClaimType.RADeath && (
                                <AddPaymentButton payments={payments} paymentIndex={paymentIndex} />
                            )}
                        </ButtonWrapper>
                        <PaymentItems
                            paymentItems={payment.paymentItems}
                            paymentIndex={paymentIndex}
                            beneficiaryId={beneficiaryId}
                            claimType={claimType}
                        />
                    </Paper>
                );
            })}
        </React.Fragment>
    );
};
function isWTICapture() {
    return <Warning style={{ color: '#ff6c35', marginLeft: '8px', height: '20px' }} />;
}
function isBankingCapture() {
    return <Warning style={{ color: '#ff6c35', marginLeft: '8px', height: '20px' }} />;
}
interface PaymentItemsProps {
    beneficiaryId: string;
    claimType: Nullable<ClaimType>;
    paymentIndex: number;
    paymentItems: PaymentItem[];
}
const PaymentItems = ({ claimType, ...rest }: PaymentItemsProps) => {
    if (claimType === ClaimType.Funeral || claimType === ClaimType.RADeath) {
        return <FuneralPaymentItems {...rest} />;
    }

    return <PaymentItemsView {...rest} />;
};

const mapStateToProps = (state: State) => {
    const claim = getClaim(state);
    return {
        beneficiaries: getPaymentBeneficiaries(claim),
        claimType: claim.claimType,
        payments: claim.payments,
    };
};

export const BeneficiaryPaymentsView = connect(mapStateToProps)(
    withStyles(styles)(beneficiaryPaymentsView)
);
